import React, { ReactElement } from 'react';
import clsx from 'clsx';
import { ManagedByIwocaPill } from 'components/ManagedByIwocaPill/ManagedByIwocaPill';
import styles from './LayoutHeadings.module.css';

type BaseProps = {
  subHeading?: string | ReactElement | null;
  headingVariant?: 'long' | 'short';
  headingAlignment?: 'left' | 'center';
  showManagedByIwocaPill?: boolean;
  className?: string;
};

type TWithHeading = { heading?: string | null; headingTestId?: string };

type TProps = BaseProps & TWithHeading;

export const LayoutHeadings = ({
  heading,
  subHeading,
  headingVariant = 'short',
  headingAlignment = 'left',
  headingTestId,
  showManagedByIwocaPill = false,
  className,
}: TProps) => {
  if (!heading && !subHeading) return null;
  return (
    <div className={clsx(styles.headings, styles[headingAlignment], className)}>
      {showManagedByIwocaPill && (
        <div className={styles.managedByIwoca}>
          <ManagedByIwocaPill size="medium" />
        </div>
      )}
      {heading && (
        <h1
          data-testid={headingTestId}
          className={clsx(styles.heading, styles[headingVariant])}
        >
          {heading}
        </h1>
      )}
      {subHeading && typeof subHeading === 'string' ? (
        <h2 className={styles.subHeading}>{subHeading}</h2>
      ) : (
        subHeading
      )}
    </div>
  );
};
